/**
 * 防火墙受限检测模块
 *
 * 检测逻辑：
 * 1. WebRTC 连接超时超过 3 次
 * 2. WebSocket 连接重试超过 3 次
 * 满足以上任一条件，则认为防火墙受限
 *
 * 注意：防火墙受限事件只会抛出一次，避免重复抛出
 */

import EventEmitter from 'eventemitter3';

export const enum FirewallDetectorEvent {
  FIREWALL_RESTRICTION = 'firewall-restriction'
}

interface FirewallDetectorEventType {
  [FirewallDetectorEvent.FIREWALL_RESTRICTION]: []
}

export default class FirewallDetector extends EventEmitter<FirewallDetectorEventType> {
  // 连接超时计数（包括 WebRTC 和 WebSocket）
  private _connectionTimeoutCount = 0;

  // 是否抛出过 FIREWALL_RESTRICTION 事件
  private _isFirewallRestrictionEventEmitted = false;

  /**
   * 增加连接超时计数
   */
  increaseTimeoutCount() {
    this._connectionTimeoutCount += 1;
    this.checkAndEmitFirewallRestriction();
  }

  /**
   * 重置超时计数（连接成功时调用）
   * 只有连续失败才认为是防火墙问题，一旦连接成功就重置计数
   */
  resetTimeoutCount() {
    this._connectionTimeoutCount = 0;
  }

  /**
   * 检查是否需要抛出防火墙受限事件
   */
  checkAndEmitFirewallRestriction() {
    if (this._connectionTimeoutCount >= 3 && !this._isFirewallRestrictionEventEmitted) {
      this._isFirewallRestrictionEventEmitted = true;
      this.emit(FirewallDetectorEvent.FIREWALL_RESTRICTION);
    }
  }

  destroy() {
    this._connectionTimeoutCount = 0;
    this._isFirewallRestrictionEventEmitted = false;
    this.removeAllListeners();
  }
}
